import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import Popup from './Popup';

import usePopupManagement from './hooks/usePopupManagement';

function ConnectedPopupWrapper({ popup }) {  
  usePopupManagement();
  return (
    <Popup content={popup.content} className={popup.className} style={popup.style} outsideClick={popup.outsideClick} />
  )
}

ConnectedPopupWrapper.propTypes = {
  popup: PropTypes.object.isRequired
}

const PopupWrapper = connect(
  state => ({ popup: state.popup })
)(ConnectedPopupWrapper);

export default PopupWrapper;
